<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" :disabled="addBtnLoading" @click="pullHandle">Pull Exchange Rate</el-button>
          <el-button @click="openExchangeRatesDialog">Exchange Rates (Avg & Spot)</el-button>
          <!-- 导出 excel -->
          <el-button type="primary" plain icon="el-icon-download" :loading="batchDownBtnLoading" @click="handleExportExcel">Export Excel</el-button>
        </div>
        <div class="fr">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-date-picker
                v-model="monthrangeArr"
                class="wd350"
                type="monthrange"
                range-separator="~"
                start-placeholder="Start month"
                end-placeholder="End month"
                value-format="yyyyMM"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column label="End of Period" prop="month" header-align="left" align="center" width="90" fixed="left" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.month">
              {{ scope.row.month.slice(0, 4) + "-" + scope.row.month.slice(4) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in exRateCurrencyExclusiveList.filter(ele => ele.currency !== 'SGD')"
          :key="`exRate-column-${item.currency}`"
          :label="getExRateColumnLabel(item)"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">{{ getExRateColumnContent(scope.row, item) }}</template>
        </el-table-column>
        <el-table-column label="attachments" header-align="center" align="center" width="130">
          <template slot-scope="scope">
            <p v-for="(item, idx) in scope.row.attachmentUrls" :key="`attachmentUrls${idx}`" class="fs12 m0">
              <a :href="item.url" target="_blank">{{ item.name }}</a>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="Create Time" prop="createTime" align="center" width="160" sortable="custom" />
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
            <el-button type="text" class="fwb" @click="toRateMatrix(scope.row)">Rate Matrix</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 拉取汇率 - 弹窗 -->
    <pull-dialog ref="pullDialog" @update="getDataList" />
    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" :exRateCurrencyExclusiveList="exRateCurrencyExclusiveList" @update="getDataList" />
    <!-- 汇率矩阵 - 弹窗 -->
    <rate-matrix-dialog ref="rateMatrixDialog" :exRateCurrencyExclusiveList="exRateCurrencyExclusiveList" />
    <!-- 汇率转换 - 弹窗 -->
    <exchange-rates-dialog ref="exchangeRatesDialog" :exRateCurrencyExclusiveList="exRateCurrencyExclusiveList" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { isNumberLike, downloadFile } from "@/utils";
import PullDialog from "./modal/Pull";
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import RateMatrixDialog from "./modal/RateMatrix";
import ExchangeRatesDialog from "./modal/ExchangeRates";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    PullDialog,
    AddOrUpdateDialog,
    RateMatrixDialog,
    ExchangeRatesDialog,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      addBtnLoading: false,
      batchDownBtnLoading: false,
      dataListLoading: false,
      dataForm: {
        monthStart: null,
        monthEnd: null,
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      monthrangeArr: null,
    };
  },
  computed: {
    ...mapState("constant", ["exRateCurrencyExclusiveList"]),
  },
  watch: {
    monthrangeArr(newValue, oldValue) {
      if (newValue) {
        this.dataForm.monthStart = newValue[0];
        this.dataForm.monthEnd = newValue[1];
      } else {
        this.dataForm.monthStart = undefined;
        this.dataForm.monthEnd = undefined;
      }
    },
  },
  methods: {
    // 动态设置table中汇率列名
    getExRateColumnLabel(data) {
      return `S$ Per ${data.exchangeRateBasis} Units of ${data.currency}`;
    },
    // 动态设置汇率列中的内容
    getExRateColumnContent(row, data) {
      const detailList = row.detailList || [];
      const exchangeRateValue = detailList.find(ele => ele.currency === data.currency)?.exchangeRateValue || undefined;
      if (isNumberLike(exchangeRateValue)) {
        return Number(exchangeRateValue);
      } else {
        return "";
      }
    },
    // 获取数据列表
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/exchangeRateByMonth/page", {
        params: params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 打开获取average exchange rate、sport rate的弹窗
    openExchangeRatesDialog() {
      this.$refs.exchangeRatesDialog.init();
    },
    // 拉取
    pullHandle() {
      this.$refs.pullDialog.init();
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
    // 查看汇率矩阵
    toRateMatrix(row) {
      this.$refs.rateMatrixDialog.init(row);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this exchange rate. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(
        `/admin/exchangeRateByMonth/batchDelete`,
        {},
        {
          params: {
            "ids[]": row.id,
          },
        },
      );
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 导出excel
    async handleExportExcel() {
      this.batchDownBtnLoading = true;
      const { monthStart, monthEnd } = this.dataForm;
      this.$http
        .get("/admin/exchangeRateByMonth/export", {
          params: { monthStart, monthEnd },
          responseType: "blob",
        })
        .then(res => {
          downloadFile(res);
        })
        .finally(() => {
          this.batchDownBtnLoading = false;
        });
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      this.getDataList();
      this.addBtnLoading = false;
    } catch (error) {}
  },
};
</script>

<style lang="scss" scoped>
.printWrap {
  .search-mian {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .search-item {
    height: 40px;
    display: flex;
    align-items: center;
    .searchSelect {
      ::v-deep .el-input__inner {
        border-right: 0px;
      }
    }
  }
  .pagination {
    height: auto;
  }
}
</style>
